export const SOCIAL = {
  github: "https://github.com/nicoleluo7",
  linkedin: "https://www.linkedin.com/in/nicoleluo7/",
  email: "mailto:nl545@cornell.edu",
};
